export default function getUrlByRole(data) {
    if (!data || data.length === 0) {
        return undefined;
    }
    const dynamicBundleItem = data.find((item) => item.role?.includes("dynamic_picture_bundle"));
    if (dynamicBundleItem) {
        return dynamicBundleItem.url;
    }
    const thumbnailItem = data.find((item) => item.role?.includes("thumbnail"));
    if (thumbnailItem) {
        return thumbnailItem.url;
    }
    return data[0].url || undefined;
}
//# sourceMappingURL=getUrlByRole.js.map